module.exports = __webpack_public_path__ + "static/tab_fct2-c45c97caccbf96e5e7afa83fb8900bbc.jpg";